import { getDataWithPromise, Globals, handleAjaxError } from "root/DataFunctions/BaseDataFns";


export const emailUserGroup = ( target, title, message, sign ) =>
{

    const url = Globals.APIFolder + '/email/users/' + target;

    const data = {
        title: title,
        message: message,
        sign: sign,
    } ;

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            console.log(response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });

}